import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';

import {createExercise} from '../../redux/slices/builder';
import {SNACKBAR_DURATION} from '../../constants';

import baseStyles from '../../css/Base.module.css';

export default function CopyExerciseDialog({isOpen, handleClose, exercise, setActiveTabIndex}) {
  const dispatch = useDispatch();
  const [name, setName] = useState(exercise?.name ? `Copy of ${exercise.name}` : '');
  const [description, setDescription] = useState(exercise?.description ?? '');
  const [isSnackbarOpen, toggleSnackbar] = useState(false);

  useEffect(() => {
    if (exercise) {
      setName(exercise?.name ? `Copy of ${exercise.name}` : '');
      setDescription(exercise?.description ?? '');
    }
  }, [exercise]);

  function handleNameChange(event) {
    setName(event.target.value);
  }

  function handleDescriptionChange(event) {
    setDescription(event.target.value);
  }

  function isSaveButtonEnabled() {
    return !!name && !!description;
  }

  async function handleSave() {
    await dispatch(
      createExercise(name, exercise.type, description, 'PRIVATE', exercise.config, [], exercise?.instructions),
    );

    handleClose();
    toggleSnackbar(true);
    setActiveTabIndex(0);
  }

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isSnackbarOpen}
        autoHideDuration={SNACKBAR_DURATION}
        onClose={toggleSnackbar}
      >
        <MuiAlert elevation={6} variant="filled" severity="success">
          Exercise saved
        </MuiAlert>
      </Snackbar>
      <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Make a copy for yourself</DialogTitle>
        <DialogContent>
          <div>
            <TextField
              variant="standard"
              value={name ?? ''}
              onChange={handleNameChange}
              label="Name"
              autoFocus
              fullWidth
              required
            />

            <TextField
              variant="standard"
              className={baseStyles['m-t-10']}
              value={description ?? ''}
              onChange={handleDescriptionChange}
              label="Description"
              multiline
              fullWidth
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button className={baseStyles['btn-pill']} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={baseStyles['btn-pill']}
            disabled={!isSaveButtonEnabled()}
            onClick={handleSave}
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
